import { PollPinSettings } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { PinBackground } from '../components/PinBackground';

export interface PollPinProps {
  pinSettings: PollPinSettings;
  isThumb?: boolean;
  children?: React.ReactNode;
}

export const PollPinComponent: React.FC<PollPinProps> = ({ pinSettings, children, isThumb }) => {
  return (
    <Wrapper>
      <PinBackground pinType="POLL" settings={pinSettings} isThumb={isThumb} />
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;
